import ApiService from "@/common/api.service"

export const CourseServcie = {
    async create(params) {
        if (params instanceof FormData) {
            return ApiService.postFormData("courses/add", params);
        }
        return ApiService.post("courses/add", params);
    },
    async update(slug, params) {
        if (params instanceof FormData) {
            return ApiService.updateFormData("/courses", slug, params);
        }
        return ApiService.update("/courses", slug, params);
    },
    async delete(slug, params) {
        return ApiService.delete("/courses/delete", slug, params);
    },
    async getCourseList(page, itemsPerPage, query) {
        let queryParam = query ? `/courses?page=${page}&pageSize=${itemsPerPage}${query}` : `/courses?page=${page}&pageSize=${itemsPerPage}`
        const res = await ApiService.get(queryParam);
        return res.data
    },

    async getCourses(query) {
        let queryParam = `/courses${query}`;
        const res = await ApiService.get(queryParam);
        return res.data
    },
    async getCourse(slug) {
        const res = await ApiService.get(`/courses/${slug}`);
        return res.data;
    }
}
